
import { useQuasar, useMeta } from 'quasar';
import { ref } from 'vue';
import { auth } from 'boot/firebase';
import { useRouter } from 'vue-router';
import { FirebaseError } from 'firebase/app';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { matCloudDone, matLogin } from '@quasar/extras/material-icons';

export default {
  name: 'LoginPage',
  setup() {
    const $q = useQuasar();
    const router = useRouter();
    const loading = ref(false);

    const email = ref('');
    const password = ref('');

    const emailError = ref('');
    const passwordError = ref('');
    const genericError = ref('');

    useMeta({
      title: 'Login to your account',
    });

    const resetErrors = () => {
      emailError.value = '';
      passwordError.value = '';
      genericError.value = '';
    };

    const onSubmit = async () => {
      try {
        if (loading.value) {
          return;
        }

        loading.value = true;
        resetErrors();
        await signInWithEmailAndPassword(auth, email.value, password.value);

        $q.notify({
          color: 'green-9',
          textColor: 'white',
          icon: matCloudDone,
          message: 'Logged in',
        });

        await router.push('/');
      } catch (err) {
        if (err instanceof FirebaseError) {
          if (err.code === 'auth/invalid-email') {
            emailError.value = 'Invalid email address format';
          } else if (err.code === 'auth/user-not-found') {
            emailError.value = 'There is no user with this email address';
          } else if (err.code === 'auth/invalid-password') {
            passwordError.value = 'Provided password is invalid. It must be at least 6 characters.';
          } else if (err.code === 'auth/wrong-password') {
            passwordError.value = 'Provided password is wrong';
          } else {
            genericError.value = err.message;
          }
        } else {
          genericError.value = String(err);
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      email,
      password,
      emailError,
      passwordError,
      genericError,
      resetErrors,
      onSubmit,
      matLogin,
    };
  },
};
